import { render, staticRenderFns } from "./deptRoleRelationship.vue?vue&type=template&id=4aae2070&"
import script from "./deptRoleRelationship.vue?vue&type=script&lang=js&"
export * from "./deptRoleRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports